import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	majorIncidentsSubTitleHeading: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.major-incidents-sub-title-heading',
		defaultMessage: 'Major incidents',
		description:
			'The subtitle heading for the Major Incidents section of the new incident management settings info card.',
	},
	majorIncidentsSubTitleBody: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.major-incidents-sub-title-body',
		defaultMessage: 'Mark Jira Service Management incidents as major for increased visibility.',
		description:
			'The body text for the major incidents section of the incident management settings info card.',
	},
	majorIncidentsLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.major-incidents-learn-more-link',
		defaultMessage: 'Learn how to add the major incident field to your service project.',
		description:
			'The learn more text for the major incidents section of the incident management settings info card.',
	},
	majorIncidentsInfo: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.major-incidents-info',
		defaultMessage:
			'Incidents in Jira Service Management are no longer synced with Opsgenie incidents.{linkStart} Switch to Opsgenie{linkEnd}',
		description:
			'The learn more text for the major incidents section of the incident management settings info card.',
	},
	createMajorIncidentFieldFlagTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-flag-title',
		defaultMessage: 'Add the major incident field to your site',
		description:
			'Title of the warning flag when the major incident field does not exist on a project.',
	},
	createMajorIncidentFieldFlagDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-flag-description',
		defaultMessage:
			'To use major incidents, first add the major incident field to your Jira Service Management site.',
		description:
			'Description of the warning flag when the major incident field does not exist on a project.',
	},
	createMajorIncidentFieldFlagButton: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-flag-button',
		defaultMessage: 'Automatically add field',
		description:
			'Action button to create the major incident field for a project when it is missing',
	},
	createMajorIncidentFieldSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-success-flag-title',
		defaultMessage: 'Major incident field added to site',
		description:
			'Title for the flag that appears after the major incident field is added to a project.',
	},
	createMajorIncidentFieldSuccessFlagDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-success-flag-description',
		defaultMessage: 'You can now add the field to your incident.',
		description:
			'Description for the flag that appears after the major incident field is added to a project.',
	},
	createMajorIncidentFieldSuccessAlertEnabledLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-success-alert-enabled-learn-more-link',
		defaultMessage: 'Learn how to create a major incident.',
		description:
			'Action link for customers to learn more about using major incidents in their service project.',
	},
	createMajorIncidentFieldErrorFlagTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-error-flag-title',
		defaultMessage: "We couldn't create the major incident field",
		description:
			'Title for the flag that appears after the server unsuccessfully tried to add the major incident field to a project.',
	},
	createMajorIncidentFieldErrorFlagDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.create-major-incident-field-error-flag-description',
		defaultMessage: 'Wait a moment, then refresh the page to try again.',
		description:
			'Description for the flag that appears after the server unsuccessfully tried to add the major incident field to a project.',
	},
	premiumLozenge: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.major-incident-field.premium-lozenge',
		defaultMessage: 'Premium',
		description: 'Premium lozenge text',
	},
});
